import type { TIrrigationDeviceStatus } from 'App/Map/types'
import { colors } from 'settings/colors'
import { getIrrigationStatusColors } from './getIrrigationStatusColors'

export const getIrrigationStatusDotColor = (status: TIrrigationDeviceStatus) => {
  if (status === 'on' || status === 'off') return getIrrigationStatusColors(status).backgroundColor

  if (status === 'error') return colors.strongRed

  return colors.grey500
}
